import { t } from "@/lib/i18n";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { MessageCircle, Copy, BellRing } from "lucide-react";
import { ClaraAvatar } from "./Brand";
import { toast } from "sonner";
import { buildWhatsAppUrl } from "@/lib/whatsapp";
import { ListenButton } from "./ListenButton";

export const ChatMessage = ({ msg, index, question, locationLabel, onFollowUp }) => {
  if (msg.role === "user") {
    return (
      <div className="flex justify-end">
        <p data-testid={`chat-user-message-${index}`} className="max-w-[85%] rounded-2xl rounded-br-sm bg-ac-strong-hover px-4 py-3 text-sm text-white">
          {msg.content}
        </p>
      </div>
    );
  }
  const done = !msg.streaming && msg.content;
  return (
    <div className="flex gap-3">
      <ClaraAvatar size="h-8 w-8" online={false} />
      <div className="min-w-0 flex-1">
        <div data-testid={`chat-ai-message-${index}`} className={`hg-md rounded-2xl rounded-tl-sm border border-ac-line bg-ac-surface px-4 py-3 text-sm text-ac-text ${msg.error ? "border-red-200 bg-red-50 text-red-700" : ""}`}>
          {msg.content ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{msg.content}</ReactMarkdown>
          ) : (
            <span className="flex gap-1 py-1" data-testid="chat-typing-indicator">
              <i className="hg-dot" /><i className="hg-dot" style={{ animationDelay: "120ms" }} /><i className="hg-dot" style={{ animationDelay: "240ms" }} />
            </span>
          )}
        </div>
        {done && !msg.error && (
          <div className="mt-2 flex flex-wrap gap-2">
            <a
              data-testid={`whatsapp-share-button-${index}`}
              href={buildWhatsAppUrl({ question, answer: msg.content, locationLabel })}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-transform hover:-translate-y-0.5"
            >
              <MessageCircle className="h-4 w-4" /> {t("msg.wa")}
            </a>
            <ListenButton text={msg.content} index={index} />
            <button
              data-testid={`followup-open-button-${index}`}
              onClick={() => onFollowUp({ question, answer: msg.content, location_label: locationLabel })}
              className="flex items-center gap-2 rounded-full border border-ac-accent bg-ac-accent-soft px-3 py-2 text-xs font-semibold text-ac-accent-ink hover:bg-ac-accent-soft2"
            >
              <BellRing className="h-3.5 w-3.5" /> {t("msg.follow")}
            </button>
            <button
              data-testid={`copy-answer-button-${index}`}
              onClick={() => navigator.clipboard.writeText(msg.content).then(() => toast.success(t("msg.copied")))}
              className="flex items-center gap-2 rounded-full border border-ac-line bg-ac-surface px-3 py-2 text-xs font-medium text-ac-muted hover:bg-ac-surface2"
            >
              <Copy className="h-3.5 w-3.5" /> {t("msg.copy")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
